import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserActivationService } from '../Services/Activation/user-activation.service';
import { CookieService } from 'ngx-cookie-service';
import { Route } from '@angular/compiler/src/core';
import { UserActivation } from '../models/UserActivation';
@Component({
  selector: 'app-activation',
  templateUrl: './activation.component.html',
  styleUrls: ['./activation.component.css']
})
export class ActivationComponent implements OnInit {
  activationStatus: string;
  ActivationForm: FormGroup;
  activationId: string;
  securityCode: string;

  constructor(private fb: FormBuilder, private route: ActivatedRoute, private activation: UserActivationService,
    private cookieService: CookieService, private router: Router) {
  // alert('activation starts constructor');
  }

  ngOnInit() {   
   try{
 // alert('activation starts ng oninit');
    this.activationId = this.route.snapshot.paramMap.get('activationId');
    this.securityCode = this.route.snapshot.paramMap.get('activationCode');
    this.ActivationForm = this.fb.group({});
    const activateObj = new UserActivation();
    activateObj.activationId = this.activationId;
    activateObj.securityCode = this.securityCode;
    setTimeout(() => {
      this.activateUser(activateObj);
    }, 100);

  }
  catch(ex)
  {
    console.log(ex);

  }
  }

  activateUser(activationObj: UserActivation) {
     
    this.activation.updateUserStatus(activationObj).subscribe(data => {
      if (data == "-1") {
        this.activationStatus = "Activation link is expired or invalid."
      }
      else {        
        this.activationStatus = data;
        if (this.cookieService.get('MD4FacilityId') != null && this.cookieService.get('MD4FacilityId') != "" && this.cookieService.get('MD4FacilityId') != undefined) {
          var facilities = this.cookieService.get('MD4FacilityId')
         // alert(facilities);
          if (facilities.includes(',')) {
            var fcltarray = facilities.split(',');
            if(fcltarray!=null && fcltarray.length>0)
            {
              var chkfaclt=fcltarray.filter(f=>f==data);
              if(chkfaclt==null || chkfaclt.length==0)
              {
                facilities += ',' + data;
              }
            }
          }
          else {
            if (data != facilities)
              facilities += ',' + data;
          }
          this.cookieService.set('MD4FacilityId', facilities, new Date(2050, 1, 25, 13, 30, 30), '/', null, false, "Strict");
        }
        else {
          this.cookieService.set('MD4FacilityId', this.activationStatus, new Date(2050, 1, 25, 13, 30, 30), '/', null, false, "Strict");
        }
        if (this.cookieService.get('MD4FacilityId') != null && this.cookieService.get('MD4FacilityId') != "" && this.cookieService.get('MD4FacilityId') != undefined)
         { 
           this.router.navigateByUrl('/login');
      }

      }
    });
  }

}
